export default "__VITE_ASSET__ZSWxtSSW__"